import React from "react";
import { Page, Text, View, Document, StyleSheet, Image } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 8,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },
  col: {
    flexDirection: "column",
  },
  boldText: {
    fontWeight: "bold",
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    textAlign: "right",
    letterSpacing: 2,
  },
  poNumber: {
    fontSize: 10,
    textAlign: "right",
  },
  textSmall: {
    fontSize: 8,
    marginBottom: 2,
  },
  sectionTitle: {
    fontWeight: "bold",
    marginTop: 10,
    marginBottom: 2,
  },
  tableHeader: {
    backgroundColor: "#3A3A3A",
    fontWeight: "bold",
    flexDirection: "row",
    padding: 4,
  },
  tableRow: {
    flexDirection: "row",
    padding: 4,
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
  },
  cell: {
    padding: 2,
    fontSize: 7,
  },
  logo: {
    height: 60,
    width: 180,
    marginBottom: 10,
  },
  companyInfo: {
    marginBottom: 15,
  },
});

const OrderInvoice = ({
  headerTitle = "Sales Order",
  company = {},
  invoiceMeta = {},
  billTo = {},
  items = [],
  totals = {},
  amountInWords = "",
  notes = "Thank you for your order!",
  signature = "Authorized Signature",
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (e) {
      return dateString;
    }
  };

  const deliveryDate = invoiceMeta.dueDate 
    ? formatDate(invoiceMeta.dueDate)
    : invoiceMeta.invoiceDate && !invoiceMeta.invoice
    ? (() => {
        try {
          const date = new Date(invoiceMeta.invoiceDate);
          date.setDate(date.getDate() + 15);
          return formatDate(date);
        } catch (e) {
          return "";
        }
      })()
    : "";

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={{ marginTop: 20 }}>
          {/* Logo and Company Info */}
          <View style={styles.row}>
            <View style={{ width: "60%" }}>
              <Image
                style={[styles.logo, { marginTop: 10 }]}
                src="/sadashri_logo-bnw.png"
              />
              <View style={styles.companyInfo}>
                <Text style={[styles.boldText, styles.textSmall]}>
                  {company.name || "Sadashri Ventures Private Limited"}
                </Text>
                {(company.addressLines || []).map((line, idx) => (
                  <Text style={styles.textSmall} key={`addr-${idx}`}>
                    {line}
                  </Text>
                ))}
                {company.cin && (
                  <Text style={styles.textSmall}>CIN : {company.cin}</Text>
                )}
                {company.gstin && (
                  <Text style={styles.textSmall}>GSTIN: {company.gstin}</Text>
                )}
                {company.email && (
                  <Text style={styles.textSmall}>{company.email}</Text>
                )}
              </View>
            </View>
            <View style={{ width: "40%", marginTop: 20 }}>
              <Text style={styles.title}>{headerTitle}</Text>
              <Text style={styles.poNumber}>{invoiceMeta.number || "N/A"}</Text>
            </View>
          </View>
        </View>

        {/* Branch Information */}
        <View style={styles.col}>
          <View style={{ width: "80%" }}>
            <Text style={styles.sectionTitle}>Branch</Text>
            <Text style={styles.textSmall}>
              {company.branchName || "Sadashri Jewels"}
            </Text>
            {(company.branchAddressLines || []).map((line, idx) => (
              <Text style={styles.textSmall} key={`branch-${idx}`}>
                {line}
              </Text>
            ))}
          </View>
        </View>

        {/* Deliver To and Date Section */}
        <View
          style={[
            styles.row,
            { justifyContent: "space-between", marginTop: 10 },
          ]}
        >
          <View style={{ width: "55%" }}>
            <Text style={styles.sectionTitle}>Customer Deatils</Text>
            {billTo.name && (
              <Text style={styles.textSmall}>{billTo.name}</Text>
            )}
            {billTo.mobile && (
              <Text style={styles.textSmall}>{billTo.mobile}</Text>
            )}
            {/* {(billTo.addressLines || []).map((line, idx) => (
              <Text style={styles.textSmall} key={`bill-${idx}`}>
                {line}
              </Text>
            ))} */}
            {/* {billTo.country && (
              <Text style={styles.textSmall}>{billTo.country}</Text>
            )}
            {billTo.gstin && (
              <Text style={styles.textSmall}>GSTIN {billTo.gstin}</Text>
            )} */}
            {billTo.email && (
              <Text style={styles.textSmall}>{billTo.email}</Text>
            )}
          </View>

          <View style={{ width: "20%", paddingLeft: 10, marginTop: 10 }}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Text style={styles.textSmall}>Date : </Text>
              <Text style={styles.textSmall}>
                {formatDate(invoiceMeta.invoiceDate)}
              </Text>
            </View>
            {deliveryDate && (
              <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Text style={styles.textSmall}>Delivery Date :</Text>
              <Text style={styles.textSmall}>{deliveryDate}</Text>
            </View>
            )} 
          </View>
        </View>

        {/* Items Table */}
        <View style={[styles.tableHeader]}>
          <Text style={[styles.cell, { width: "5%", color: "white" }]}>#</Text>
          <Text style={[styles.cell, { width: "20%", color: "white" }]}>
            Item & Description
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            HSN/SAC
          </Text>
          <Text style={[styles.cell, { width: "5%", color: "white" }]}>
            Qty
          </Text>
          <Text style={[styles.cell, { width: "12%", color: "white" }]}>
            Purity
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            Gross.wt
          </Text>
          <Text style={[styles.cell, { width: "7%", color: "white" }]}>
            St.wt
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            Net.wt
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            Rate
          </Text>
          <Text style={[styles.cell, { width: "7%", color: "white" }]}>
            V.A
          </Text>
          <Text style={[styles.cell, { width: "7%", color: "white" }]}>MC</Text>
          <Text style={[styles.cell, { width: "7%", color: "white" }]}>
            St.Amt
          </Text>
          <Text style={[styles.cell, { width: "15%", color: "white" }]}>
            Status
          </Text>
          <Text style={[styles.cell, { width: "10%", color: "white" }]}>
            Total
          </Text>
        </View>

        {items.map((item, index) => (
          <View
            style={[
              styles.tableRow,
              { fontFamily: "Times-Roman", flexDirection: "row" },
            ]}
            key={`item-${index}`}
          >
            <Text style={[styles.cell, { width: "5%" }]}>
              {item.sno || index + 1}
            </Text>
            <Text style={[styles.cell, { width: "20%", color: "#666" }]}>
              {item.description || "-"}
            </Text>
            <Text style={[styles.cell, { width: "10%" }]}>
              {item.hsn || "-"}
            </Text>
            <Text style={[styles.cell, { width: "5%" }]}>
              {item.qty ?? "-"}
            </Text>
            <Text style={[styles.cell, { width: "12%" }]}>
              {item.purity ?? "-"}
            </Text>
            <Text style={[styles.cell, { width: "10%" }]}>
              {item.grossWeight ?? "-"}
            </Text>
            <Text style={[styles.cell, { width: "7%" }]}>
              {item.stoneWeight ?? "-"}
            </Text>
            <Text style={[styles.cell, { width: "10%" }]}>
              {item.netWeight ?? "-"}
            </Text>
            <Text style={[styles.cell, { width: "10%" }]}>
              {item.rate ?? "0.00"}
            </Text>
            <Text style={[styles.cell, { width: "7%" }]}>
              {item.vaPercent ?? "-"}
            </Text>
            <Text style={[styles.cell, { width: "7%" }]}>
              {item.mc ?? "-"}
            </Text>
            <Text style={[styles.cell, { width: "7%" }]}>
              {item.stoneAmount ?? "0.00"}
            </Text>
            <Text style={[styles.cell, { width: "15%" }]}>
              {item.status || "Not Delivered"}
            </Text>
            <Text style={[styles.cell, { width: "10%" }]}>
              {item.amount ?? "0.00"}
            </Text>
          </View>
        ))}

        {/* Summary Section */}
        <View style={[styles.row, { marginTop: 20 }]}>
          <View style={{ width: "70%" }} />
          <View style={{ width: "30%", paddingLeft: 10 }}>
            <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 5,
                }}
              >
                <Text style={styles.textSmall}>(-)Discount :</Text>
                <Text style={styles.textSmall}>
                  {totals.discount || "0.00"}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 5,
                }}
              >
                <Text style={styles.textSmall}>(-)Festival Offer :</Text>
                <Text style={styles.textSmall}>
                {(totals.festivalOffer ?? "0.00").replace(/[₹,]/g, "")}
              </Text>
            </View>
              
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 5,
              }}
            >
              <Text style={styles.textSmall}>Sub Total :</Text>
              <Text style={styles.textSmall}>
                {totals.subtotal?.replace(/[₹,]/g, "") || "0.00"}
              </Text>
            </View>
            
              
            {(totals.taxRows || []).map((row, idx) => {
              if (row.label === "CGST" || row.label === "SGST" || row.label === "IGST") {
                return (
                  <View
                    key={`tax-${idx}`}
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginBottom: 5,
                    }}
                  >
                    <Text style={styles.textSmall}>{row.label}:</Text>
                    <Text style={styles.textSmall}>
                      {row.amount?.replace(/[₹,]/g, "") || "0.00"}
                    </Text>
                  </View>
                );
              }
              return null;
            })}
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 5,
              }}
            >
              <Text style={[styles.textSmall]}>Net Bill Value:</Text>
              <Text style={[styles.textSmall]}>
                {totals.total?.replace(/[₹,]/g, "") || "0.00"}
              </Text>
            </View>
            {totals.oldItemsAmount && parseFloat(totals.oldItemsAmount.replace(/[₹,]/g, "")) > 0 && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 5,
                }}
              >
                <Text style={[styles.textSmall]}>(-)Old Items Amt:</Text>
                <Text style={[styles.textSmall]}>
                  {totals.oldItemsAmount.replace(/[₹,]/g, "")}
                </Text>
              </View>
            )}
            {totals.schemeAmount && parseFloat(totals.schemeAmount.replace(/[₹,]/g, "")) > 0 && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 5,
                }}
              >
                <Text style={[styles.textSmall]}>(-)Scheme Amt:</Text>
                <Text style={[styles.textSmall]}>
                  {totals.schemeAmount.replace(/[₹,]/g, "")}
                </Text>
              </View>
            )}//
            {totals.salesReturnAmount && parseFloat(totals.salesReturnAmount.replace(/[₹,]/g, "")) > 0 && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 5,
                }}
              >
                <Text style={[styles.textSmall]}>(-)Sale Return Amt:</Text>
                <Text style={[styles.textSmall]}>
                  {totals.salesReturnAmount.replace(/[₹,]/g, "")}
                </Text>
              </View>
            )}
            {totals.advanceAmount && parseFloat(totals.advanceAmount.replace(/[₹,]/g, "")) > 0 && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 5,
                }}
              >
                <Text style={[styles.textSmall]}>Advance:</Text>
                <Text style={[styles.textSmall]}>
                  {totals.advanceAmount.replace(/[₹,]/g, "")}
                </Text>
              </View>
            )}
            {totals?.paymentMade?.cash_amount > 0 && (
              <View
                style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 5,
                  }}
              >
                <Text style={styles.textSmall}>Cash Amount :</Text>
                <Text style={styles.textSmall}>{totals.paymentMade.cash_amount}</Text>
              </View>
            )}

            {totals?.paymentMade?.card_amt > 0 && (
              <View
                style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 5,
                  }}
              >
                <Text style={styles.textSmall}>Card Amount :</Text>
                <Text style={styles.textSmall}>{totals.paymentMade.card_amt}</Text>
              </View>
            )}

            {totals?.paymentMade?.chq_amt > 0 && (
              <View
                style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 5,
                  }}
              >
                <Text style={styles.textSmall}>Cheque Amount :</Text>
                <Text style={styles.textSmall}>{totals.paymentMade.chq_amt}</Text>
              </View>
            )}

            {totals?.paymentMade?.online_amt > 0 && (
              <View
                style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 5,
                  }}
              >
                <Text style={styles.textSmall}>Online Amount :</Text>
                <Text style={styles.textSmall}>{totals.paymentMade.online_amt}</Text>
              </View>
            )}

            {/* {totals?.paymentMade?.receipts_amt > 0 && (
              <View
                style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 5,
                  }}
              >
                <Text style={styles.textSmall}>Receipts Amount :</Text>
                <Text style={styles.textSmall}>{totals.paymentMade.receipts_amt}</Text>
              </View>
            )} */}

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 5,
              }}
            >
              <Text style={[styles.textSmall, { fontWeight: "bold" }]}>
                Net Amount:
              </Text>
              <Text style={[styles.textSmall, { fontWeight: "bold" }]}>
                {totals.netPayableAmount?.replace(/[₹,]/g, "") || "0.00"}
              </Text>
            </View>
          </View>
        </View>

        {/* Signatures */}
        <View style={[styles.row, { marginTop: 50 }]}>
          <Text>
            Sadashri Ventures Signature{" "}
            <Text style={{ fontWeight: "bold" }}>___________________</Text>
          </Text>
          <View style={[styles.row]}>
            {/* Left: Label */}
            <Text style={{ marginRight: 10 }}>Authorized Signature</Text>

            {/* Right: Stamp & Line */}
            <View style={{ flexDirection: "column" , marginTop:-50}}>
              <Image
                src={"/stamp.png"}
                style={{
                  width: 95,
                  height: 95,
                  objectFit: "contain",
                }}
              />
              <Text style={{ fontWeight: "bold", marginTop: -45, marginLeft:5 }}>
                ___________________
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default OrderInvoice;